import React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

const CheckoutCard = (props) => {
  return (
    <div className={cn('checkout-card', props.className)}>
      {props.title && (
        <h2
          className={cn('checkout-card__title', {
            'checkout-card__title--always-visible': props.showTitleOnMbl,
          })}
        >
          {props.title}
        </h2>
      )}
      {props.children}
    </div>
  );
};

CheckoutCard.propTypes = {
  prefixesAreVisible: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  title: PropTypes.string,
  showTitleOnMbl: PropTypes.bool.isRequired,
};

CheckoutCard.defaultProps = {
  showTitleOnMbl: false,
};

export { CheckoutCard };
